/**
 * BlueBean ログイン情報(BB ID／パスワード一覧)。bb_credentials/{bb_id}
 * admin のみ読み書き(firestore.rules)。監査ログにはパスワードを残さない。
 * ※システム自体のBlueBean API認証情報は Functions Secret で管理し、ここには入れない
 */
import { collection, deleteDoc, doc, getDocs, serverTimestamp, setDoc } from 'firebase/firestore';
import { getDb } from '@core/lib/firebase';
import { writeAuditLog } from '@core/lib/auditLog';
import type { BbCredential } from '@core/lib/types';

export async function fetchBbCredentials(): Promise<Map<string, BbCredential>> {
  const snap = await getDocs(collection(getDb(), 'bb_credentials'));
  return new Map(snap.docs.map((d) => [d.id, { id: d.id, ...(d.data() as object) } as BbCredential]));
}

export async function saveBbCredential(
  input: { bb_id: string; op_id: string | null; password: string; note: string },
  userId: string,
): Promise<void> {
  const bbId = input.bb_id.trim();
  if (!bbId) throw new Error('BB IDが空です');
  if (!input.password) throw new Error('パスワードを入力してください');
  await setDoc(
    doc(getDb(), 'bb_credentials', bbId),
    {
      bb_id: bbId,
      op_id: input.op_id,
      password: input.password,
      note: input.note.trim() || null,
      updated_by: userId,
      updated_at: serverTimestamp(),
    },
    { merge: true },
  );
  await writeAuditLog({
    targetType: 'bb_credential',
    targetId: bbId,
    action: 'bb-credential-update',
    by: userId,
    changes: ['パスワードを更新(内容は記録しない)'],
  });
}

export async function deleteBbCredential(bbId: string, userId: string): Promise<void> {
  await deleteDoc(doc(getDb(), 'bb_credentials', bbId));
  await writeAuditLog({ targetType: 'bb_credential', targetId: bbId, action: 'bb-credential-delete', by: userId });
}
